import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { AudienceListType, SegmentTreeNode } from '../../../../../../../modules/audiences/AudienceForm/types';
import { TraverseNode } from './TraverseNode';

type TreeProps = {
  title: string;
  treeItems: SegmentTreeNode[];
  type: AudienceListType;
} & ({ readOnly: true } | { readOnly?: false; onLeafDelete: (node: SegmentTreeNode) => void });

export const Tree = ({ treeItems, title, type, ...rest }: TreeProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        flexDirection: 'column',
      }}
    >
      <Typography
        variant="captionBold"
        color="textSecondary"
        component="p"
        sx={{
          textTransform: 'uppercase',
          my: 1,
        }}
      >
        {title}
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {treeItems.map(node => (
          <TraverseNode key={node.id} node={node} prefix={[]} type={type} {...rest} />
        ))}
      </Box>
    </Box>
  );
};
